import { CANVAS_SIZE } from "@/lib/constants/slides";
import { useAppSelector } from "@/store/hooks";
import type { ReactNode } from "react";
import { BiChevronLeft } from "react-icons/bi";

interface LiveMobileViewContainerProps {
  children: ReactNode;
  className?: string;
  backgroundColor?: string;
}

export function LiveMobileViewContainer({
  children,
  className = "",
  backgroundColor = "#FFF7DD",
}: LiveMobileViewContainerProps) {
  const { scale } = useAppSelector((state) => state.slideEditor.present);

  return (
    <div
      className={`relative shadow-lg flex flex-col items-center px-0 py-3 gap-3 ${className}`}
      style={{
        height: CANVAS_SIZE.freeform.size.height,
        aspectRatio: CANVAS_SIZE.freeform.aspectRatio,
        transformOrigin: "center center",
        transform: `scale(${scale})`,
        backgroundColor,
      }}
    >
      {/* Top Bar */}
      <div className="flex items-center justify-center w-full h-16">
        <BiChevronLeft
          className="text-gray-600 rounded-full bg-white bg-opacity-50 mr-2"
          size={40}
        />
        <div className="relative bg-[#FFE89F] w-[80%] h-3 rounded-lg overflow-hidden">
          <div className="absolute left-0 h-3 w-[40%] bg-[#B8ECFF] rounded-lg" />
        </div>
      </div>
      {children}
    </div>
  );
}
